import { Box, BoxProps } from "@mui/material";
import type { SystemProps } from "@mui/system";
import type { Theme } from "@mui/material/styles";
import React, { ReactNode } from "react";
import { NAVBAR_HEIGHT } from "@/components/app/nav-bar";
import { DEFAULT_FONTSIZE } from "@/utils/utils";
import { mergeSx, splitSystemProps } from "@/utils/system-props";

/** Card chrome above the table: ElevatedPaper padding, title row and toolbar. */
const TABLE_CHROME_PX = 79.2;
const TABLE_CHROME_SMALL_PX = 156;

type GlobalTableHeightWrapperProps = {
  children: ReactNode;
  small?: boolean;
} & BoxProps &
  SystemProps<Theme>;

const GlobalTableHeightWrapper: React.FC<GlobalTableHeightWrapperProps> = ({
  children,
  small,
  sx,
  ...others
}) => {
  const { systemSx, rest } = splitSystemProps(others);
  return (
    <Box
      {...rest}
      sx={mergeSx(
        {
          marginTop: 1,
          fontSize: `${DEFAULT_FONTSIZE.fontSize}`,
          ...systemSx,
          height:
            systemSx.height ??
            `calc(100vh - ${NAVBAR_HEIGHT} - ${
              small ? TABLE_CHROME_SMALL_PX : TABLE_CHROME_PX
            }px)`,
        },
        sx
      )}
    >
      {children}
    </Box>
  );
};

export { GlobalTableHeightWrapper };
